(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchstatistics/assets/javascripts/models/statmatchstatistics.js') >= 0) return;  svs.modules.push('/components/statistics/matchstatistics/assets/javascripts/models/statmatchstatistics.js'); 

(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  var log = new svs.core.log.Logger('svs.statistics.statMatchStatistics');

  svs.statistics.models.statMatchStatistics = Backbone.Model.extend({
    numOfMatches: 5,
    url: function() {
      return (
        svs.core.jupiter.url() +
        '/multifetch?urls=/sport/1/matches/' +
        this.urlParams.id +
        '/statistics|' +
        '/sport/1/teams/' +
        this.homeTeam.id +
        '/lastmatches?count=10|/sport/1/teams/' +
        this.awayTeam.id +
        '/lastmatches?count=10|' +
        encodeURIComponent(
          '/sport/1/teams/mutuals?count=5&team1Id=' +
            this.homeTeam.id +
            '&team2Id=' +
            this.awayTeam.id +
            '&meMatchId=' +
            this.urlParams.id
        )
      );
    },

    initialize: function(options) {
      var _self = this;
      this.urlParams = options.urlParams;
      this.socketResourcePath =
        '/sport/1/matches/' + this.urlParams.id + '/statistics';

      if (this.urlParams.numberOfMatches) {
        this.set('numberOfMatches', this.urlParams.numberOfMatches, {
          silent: true
        });
      }

      if (this.urlParams.match) {
        if (_.isObject(this.urlParams.match.get('match'))) {
          this.homeTeam = this.urlParams.match.get('match').homeTeam;
          this.awayTeam = this.urlParams.match.get('match').awayTeam;
        }
      }

      if ((((svs.statistics || {}).data || {}).matchModels || {}).statistics) {
        var fakeMultiFetchResponse = {};
        fakeMultiFetchResponse.responses = [
          svs.statistics.data.matchModels.statistics
        ];
        if (
          (((svs.statistics || {}).data || {}).matchModels || {})
            .hometeamlatestmatches
        ) {
          fakeMultiFetchResponse.responses[1] =
            svs.statistics.data.matchModels.hometeamlatestmatches;
        }
        if (
          (((svs.statistics || {}).data || {}).matchModels || {})
            .awayteamlatestmatches
        ) {
          fakeMultiFetchResponse.responses[2] =
            svs.statistics.data.matchModels.awayteamlatestmatches;
        }
        if ((((svs.statistics || {}).data || {}).matchModels || {}).mutuals) {
          fakeMultiFetchResponse.responses[3] =
            svs.statistics.data.matchModels.mutuals;
        }
        this.parse(fakeMultiFetchResponse);
        this.startPush(false);

        return this;
      }
      this.fetch({
        error: function() {
          _self.trigger('fetchError');
        }
      }).done(function() {
        _self.startPush(false);
      });
    },

    updateFormLatest: function(callOptions) {
      var urls = [];
      urls.push('/sport/1/matches/' + this.urlParams.id + '/statistics');
      urls.push(
        '/sport/1/teams/' +
          this.homeTeam.id +
          '/lastmatches?count=10&selection=' +
          callOptions.selection
      );
      urls.push(
        '/sport/1/teams/' +
          this.awayTeam.id +
          '/lastmatches?count=10&selection=' +
          callOptions.selection
      );
      urls.push(
        '/sport/1/teams/mutuals?count=5&team1Id=' +
          this.homeTeam.id +
          '&team2Id=' +
          this.awayTeam.id +
          '&meMatchId=' +
          this.urlParams.id
      );

      var self = this,
        options = {
          method: 'GET',
          path: '/multifetch?urls=' + encodeURIComponent(urls.join('|'))
        };

      svs.core.jupiter.call(
        options,
        function(response) {
          self.parse(response, callOptions.selection);
        },
        function(error) {
          log.error('Could not fetch match statistics', error);
        }
      );
    },

    statisticsParse: function(response) {
      var statistics,
        previouslyStatistics = false;
      if (
        _.isObject(response) &&
        (response.error === undefined || response.error === null)
      ) {
        statistics = false;
        if (_.isObject(response.statistics)) {
          statistics = response.statistics;

          if (_.isObject(statistics.sport)) {
            this.set('sport', statistics.sport, { silent: true });
          }
        }
        if (statistics) {
          if (this.get('statistics')) {
            statistics.mutuals =
              statistics.mutuals || this.get('statistics').mutuals;

            statistics.formatMutuals =
              statistics.formatMutuals || this.get('statistics').formatMutuals;

            statistics.latestMeetingsList =
              statistics.latestMeetingsList ||
              this.get('statistics').latestMeetingsList;

            if (
              statistics.mutuals &&
              statistics.formatMutuals &&
              statistics.latestMeetingsList
            ) {
              previouslyStatistics = true;
            }
          }
          if (!previouslyStatistics && _.isArray(statistics.mutuals)) {
            _.each(statistics.mutuals, function(matchItem) {
              if (matchItem.match) {
                matchItem.match.formatedStartTime = moment(
                  matchItem.match.startTime
                ).format('D/M, YYYY');
              }
            });
            statistics.latestMeetingsList = statistics.mutuals.slice(
              0,
              this.numOfMatches
            );

            if (!statistics.formatMutuals) {
              var numOfLatestMeetings = this.numOfMatches - 1;
              if (
                numOfLatestMeetings >
                statistics.latestMeetingsList.length - 1
              ) {
                numOfLatestMeetings = statistics.latestMeetingsList.length - 1;
              }
              if (
                _.isObject(statistics.latestMeetingsList[numOfLatestMeetings])
              ) {
                var matchMeetingItem =
                  statistics.latestMeetingsList[numOfLatestMeetings];
                if (matchMeetingItem.history) {
                  statistics.formatMutuals = [
                    matchMeetingItem.history.homeWins,
                    matchMeetingItem.history.draws,
                    matchMeetingItem.history.awayWins
                  ];
                }
              }
            }
          }
          statistics = this.setUpMatchStatistics(
            statistics,
            this.getPreviousSelectedMatchStatistic()
          );
        }
      }
      return statistics;
    },

    setResultFormat: function(match) {
      if (!_.isArray(match.result)) {
        match.result = [match.result];
      }
      return match;
    },

    statisticsParseElastic: function(response) {
      var self = this;
      var statistics;
      if (_.isObject(response) && !response.error) {
        statistics = false;
        if (_.isObject(response[0].statistics)) {
          statistics = response[0].statistics;
          statistics.mutuals =
            response[3] && response[3].result ? response[3].result : [];
        }

        if (statistics && _.isObject(statistics.sport)) {
          this.set('sport', statistics.sport, { silent: true });
        }

        if (statistics) {
          if (_.isArray(statistics.mutuals)) {
            var draws = 0;
            this.homeTeam.wins = 0;
            this.awayTeam.wins = 0;
            statistics.latestMeetingsList = statistics.mutuals;

            _.each(statistics.latestMeetingsList, function(matchItem) {
              if (matchItem && matchItem.match) {
                matchItem.match.formatedStartTime = moment(
                  matchItem.match.startTime
                ).format('D/M, YYYY');
                matchItem.match = self.setResultFormat(matchItem.match);
                var result = svs.utils.result.getResult(matchItem.match, true);

                if (result) {
                  if (
                    result.result &&
                    (result.result.home && result.result.away)
                  ) {
                    matchItem.match.homeTeam.result = result.result.home;
                    matchItem.match.awayTeam.result = result.result.away;

                    if (
                      parseInt(result.result.home, 10) >
                      parseInt(result.result.away, 10)
                    ) {
                      if (result.homeTeam.id === self.homeTeam.id) {
                        self.homeTeam.wins++;
                      } else if (result.homeTeam.id === self.awayTeam.id) {
                        self.awayTeam.wins++;
                      }
                    } else if (
                      parseInt(result.result.home, 10) <
                      parseInt(result.result.away, 10)
                    ) {
                      if (result.awayTeam.id === self.homeTeam.id) {
                        self.homeTeam.wins++;
                      } else if (result.awayTeam.id === self.awayTeam.id) {
                        self.awayTeam.wins++;
                      }
                    } else {
                      draws++;
                    }
                  }
                }
                matchItem.match.id = matchItem.match.matchId;
              }
            });
            statistics.formatMutuals = [
              this.homeTeam.wins,
              draws,
              this.awayTeam.wins
            ];
          }
          statistics = this.setUpMatchStatistics(
            statistics,
            this.getPreviousSelectedMatchStatistic()
          );
        }
      }
      return statistics;
    },

    getPreviousSelectedMatchStatistic: function() {
      var statistics = this.get('statistics');

      if (!statistics) {
        return null;
      }

      var matchPeriodStatistics = statistics.matchPeriodStatistics;

      if (!matchPeriodStatistics) {
        return null;
      }

      for (var prop in matchPeriodStatistics) {
        if (Object.prototype.hasOwnProperty.call(matchPeriodStatistics, prop)) {
          if (matchPeriodStatistics[prop].selected === true) {
            return prop;
          }
        }
      }

      return null;
    },

    setUpMatchStatistics: function(statistics, prevSelected) {
      var ix;
      statistics.matchStatistics = this.formatMatchStatistics(
        statistics.matchStatistics || [],
        statistics.sport ? statistics.sport.id : '',
        statistics.matchId
      );
      for (ix in statistics.matchPeriodStatistics) {
        if (
          Object.prototype.hasOwnProperty.call(
            statistics.matchPeriodStatistics,
            ix
          )
        ) {
          statistics.matchPeriodStatistics[ix] = this.formatMatchStatistics(
            statistics.matchPeriodStatistics[ix] || [],
            statistics.sport ? statistics.sport.id : '',
            statistics.matchId
          );
        }
      }

      if (_.has(statistics, 'league') && _.isObject(statistics.league)) {
        statistics.league = this.getStatusFunction(
          'formatTable',
          statistics.league
        );
      }

      if (statistics.matchPeriodStatistics) {
        var i = 0;
        for (ix in statistics.matchPeriodStatistics) {
          if (statistics.matchPeriodStatistics[ix]) {
            var title = svs.utils.format.capitalize(ix);
            title = title
              .replace('Period', 'Period ')
              .replace('Total', 'Totalt')
              .replace('Overtime', 'Övertid');
            statistics.matchPeriodStatistics[ix].title = title;
            statistics.matchPeriodStatistics[ix].selected =
              prevSelected !== null ? ix === prevSelected : ix === 'total';
            statistics.matchPeriodStatistics[ix].index = i++;
          } else {
            delete statistics.matchPeriodStatistics[ix];
          }
        }
      }
      return statistics;
    },

    formatMatchStatistics: function(matchesStats, sportId, matchId) {
      if (!_.isArray(matchesStats)) {
        log.warn('invalid datatype', matchesStats, sportId, matchId);
        return null;
      }

      matchesStats = this.sortStatisticsKeys(
        matchesStats,
        'TOTAL: Skott på mål',
        0
      );
      matchesStats = this.sortStatisticsKeys(matchesStats, 'Skott på mål', 0);
      matchesStats = this.sortStatisticsKeys(
        matchesStats,
        'Antal räddningar',
        0
      );

      for (var i = 0; i < matchesStats.length; i++) {
        matchesStats[i].home = matchesStats[i].home + '';
        matchesStats[i].away = matchesStats[i].away + '';

        if (sportId === svs.statistics.constants.TENNIS) {
          if (!matchesStats[i].home) matchesStats[i].home = '0';

          if (!matchesStats[i].away) matchesStats[i].away = '0';
        } else {
          if (
            !matchesStats[i].home ||
            isNaN(parseFloat(matchesStats[i].home))
          ) {
            matchesStats[i].home = '0';
          }

          if (
            !matchesStats[i].away ||
            isNaN(parseFloat(matchesStats[i].away))
          ) {
            matchesStats[i].away = '0';
          }
        }

        matchesStats[i].name = matchesStats[i].name.replace('TOTAL: ', '');
        if (matchesStats[i].name === 'Räddningsprocent') {
          matchesStats[i].formattedHome = matchesStats[i].home.replace(
            ',',
            '.'
          );
          matchesStats[i].formattedAway = matchesStats[i].away.replace(
            ',',
            '.'
          );

          matchesStats[i].formattedHome = this.formatValueToDecimal(
            parseFloat(matchesStats[i].formattedHome) * 100 + '',
            2
          );
          matchesStats[i].formattedAway = this.formatValueToDecimal(
            parseFloat(matchesStats[i].formattedAway) * 100 + '',
            2
          );
        }

        if (matchesStats[i].name === 'Skott på mål') {
          matchesStats.shootsOnGoal = true;
        }

        if (matchesStats[i].name === 'Missade skott') {
          matchesStats.shootsOutsideGoal = true;
        }

        if (
          matchesStats[i].percentage &&
          !(matchesStats[i].name === 'Bollinnehav')
        ) {
          matchesStats[i].home = matchesStats[i].home.replace(',', '.');
          matchesStats[i].home = this.formatValueToDecimal(
            parseFloat(matchesStats[i].home) * 100 + '',
            2,
            true
          );
          matchesStats[i].away = matchesStats[i].away.replace(',', '.');
          matchesStats[i].away = this.formatValueToDecimal(
            parseFloat(matchesStats[i].away) * 100 + '',
            2,
            true
          );
        }

        matchesStats[i].name = matchesStats[i].name
          .replace('(%)', '')
          .replace('%', '');
      }
      return matchesStats;
    },
    formatValueToDecimal: function(value, decimals, removeUnnecessaryDecimals) {
      removeUnnecessaryDecimals = removeUnnecessaryDecimals || false;
      var formattedValue = svs.utils.format.formatValueToCommaStr(
        value,
        decimals,
        true
      );
      if (removeUnnecessaryDecimals) {
        if (formattedValue.indexOf(',00') > -1) {
          formattedValue = parseInt(formattedValue, 10).toString();
        } else if (formattedValue.charAt(formattedValue.length - 1) === '0') {
          formattedValue = formattedValue.substr(0, formattedValue.length - 1);
        }
      }
      return formattedValue;
    },
    sortStatisticsKeys: function(matchesStats, statKey, posInList) {
      if (_.isArray(matchesStats)) {
        var needle = null;
        for (var i = 0; i < matchesStats.length; i++) {
          if (
            !_.has(matchesStats[i], 'home') &&
            !_.has(matchesStats[i], 'away')
          ) {
            matchesStats.splice(i, 1);
          }

          if (matchesStats[i].name === statKey) {
            needle = matchesStats.splice(i, 1);
            break;
          }
        }
        if (needle) {
          matchesStats.splice(posInList, 0, needle[0]);
        }
        return matchesStats;
      }
      return null;
    },
    parse: function(response, selection) {
      if (typeof selection !== 'string') {
        selection = 'all';
      }

      if (_.isObject(response)) {
        var statResponse;

        if (!!response.responses && response.responses[0].error === null) {
          selection = selection || 'all';
          statResponse = this.statisticsParseElastic(response.responses);
          statResponse.latestMatches = statResponse.latestMatches || {};

          if (!!response.responses[1] && response.responses[1].error === null) {
            statResponse.latestMatches.home = {};
            statResponse.latestMatches.home[selection] =
              response.responses[1].result;
          }
          if (!!response.responses[2] && response.responses[2].error === null) {
            statResponse.latestMatches.away = {};
            statResponse.latestMatches.away[selection] =
              response.responses[2].result;
          }

          statResponse.latestMatches = this.latestMatchesFormateTime(
            statResponse.latestMatches
          );

          this.set('latestMatches', statResponse.latestMatches, {
            silent: true
          });
        } else {
          statResponse = this.statisticsParse(response);

          if (_.isObject(this.get('latestMatches'))) {
            statResponse.latestMatches = this.get('latestMatches');
          }
        }

        if (_.isObject(statResponse)) {
          this.set('statistics', statResponse, { silent: true });
        }

        try {
          if (
            this.validateData(this.get('statistics'), 'startTime') &&
            this.validateData(this.get('statistics'), 'status')
          ) {
            if (
              !this.getStatusFunction('subscribeMatch', {
                time: this.get('statistics').startTime,
                status: this.get('statistics').status
              })
            ) {
              this.stopPush();
            }
          }
        } catch (e) {
        }

        if (this.get('numberOfMatches') !== undefined) {
          this.numOfMatches = this.get('numberOfMatches');
        }

        if (this.numOfMatches === 5) this.trigger('change', this);
        else this.trigger('change:formLatestMatches');
      }
    },
    latestMatchesFormateTime: function(latestMatches) {
      _.each(latestMatches, function(homeAwayMatches) {
        _.each(homeAwayMatches, function(homeAwayMatch) {
          _.each(homeAwayMatch, function(matchItem) {
            if (((matchItem || {}).match || {}).startTime) {
              matchItem.formatedStartTime = moment(
                matchItem.match.startTime
              ).format('D/M, YYYY');
            }
          });
        });
      });
      return latestMatches;
    },
    validateData: function(object, key) {
      if (!!object && _.has(object, key)) {
        return true;
      }
      return false;
    },
    reverseSortAttr: function(response, attr) {
      var items = response;
      items = _.sortBy(items, function(item) {
        return parseInt(item[attr], 10);
      }).reverse();

      return items;
    },
    update: function(param) {
      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('STATISTICS', param.statistics);
      }

      if (param) {
        this.set('numberOfMatches', 5, { silent: true });
        this.set(this.parse(param, {}));
      }
    },

    hasData: function() {
      return this.fetched;
    },

    startPush: function(getInitialData) {
      if (window.location.href.indexOf('isMocked') > -1) {
        this.isMock = true;
      }
      if (
        this.validateData(this.get('statistics'), 'startTime') &&
        this.validateData(this.get('statistics'), 'status')
      ) {
        if (
          this.getStatusFunction('subscribeMatch', {
            time: this.get('statistics').startTime,
            status: this.get('statistics').status
          }) ||
          this.isMock
        ) {
          try {
            svs.core.socket.subscribe(
              this.socketResourcePath,
              this.update,
              this,
              getInitialData
            );
            this.subscribed = true;
          } catch (e) {
            log.error(
              'Socket subscribe error, path=' + this.socketResourcePath,
              e
            );
          }
        }
      }
    },
    initTheme: function() {
      if (this.get('sport')) {
        var sport = this.get('sport');
        if (!this.theme) {
          this.theme = new svs.sport.themeLoader({
            sport: sport.id
          });
        }
      }
      if (!this.theme) {
        log.info('theme not found');
        this.clear({ silent: true });
      }
    },

    getStatusFunction: function(func, id) {
      var returner = false;

      if (!this.theme) {
        this.initTheme();
      }

      if (this.theme) {
        this.theme.load(function(template, init) {
          if (init) {
            returner = init(func, id);
          }
        }, 'init');
      }
      return returner;
    },

    setPeriodSelected: function(index) {
      var periodStatistics = this.get('statistics').matchPeriodStatistics;
      for (var ix in periodStatistics) {
        if (periodStatistics[ix].index === index) {
          periodStatistics[ix].selected = true;
          this.get('statistics').matchStatistics = periodStatistics[ix];
        } else {
          periodStatistics[ix].selected = false;
        }
      }
      this.trigger('periodSelected');
    },

    stopPush: function() {
      try {
        if (this.socketResourcePath && this.subscribed) {
          svs.core.socket.unsubscribe(this.socketResourcePath, this.update);
          this.subscribed = false;
        }
      } catch (e) {
        log.error(
          'Socket unsubscribe error, path=' + this.socketResourcePath,
          e
        );
      }
    },

    dispose: function() {
      this.stopPush();
      this.clear(true);
    }
  });
})(Backbone, _, svs);

 })(window);